import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import {UserService} from './user.service';
import {RSLoadingModalService} from '../../libs/rsloading/rsloading.service';
import {DataService} from "./data.service";

@Injectable()
export class FirebaseAuthResolver  {
    constructor(private router: Router, private userService: UserService, private dataService: DataService, private loadingService: RSLoadingModalService) {}

    // Apply this to paths that need to wait for Firebase's first load
    resolve(route: ActivatedRouteSnapshot): boolean | Promise<boolean> {
        console.log('FirebaseAuthResolver');
        return new Promise((resolve, reject) => {
            // const id = +route.params.id;
            if (this.userService.fbLoading) {
                this.loadingService.show();
                this.userService.fbLoading.then(async () => {
                    this.loadingService.hide();
                    if (this.userService.hasActiveUser) {
                        setTimeout(async () => {
                          if (this.dataService.initialLoad) {
                            await this.dataService.initialLoad;
                          }
                          resolve(true);
                        }, 250);
                    } else {
                        console.error('FirebaseAuthResolver::: No active user');
                        this.router.navigate(['/login']);
                        reject();
                    }
                });
            } else {
                resolve(true);
            }
        });
    }
}

@Injectable()
export class FirebaseAwaitResolver  {
    constructor(private router: Router, private userService: UserService, private loadingService: RSLoadingModalService) {}

    // Apply this to paths that need to wait for Firebase's first load
    resolve(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
        // const id = +route.params.id;
        if (this.userService.fbLoading) {
            this.loadingService.show();
            return new Promise((resolve, reject) => {
                this.userService.fbLoading.then(() => {
                    resolve(true);
                    this.loadingService.hide();
                });
            });
        } else {
            return true;
        }
    }
}
